<script setup lang="ts">
import { BtnPrimary } from '@shared/ui/buttons'

import { useButtonTaskUpdate } from '../../model/info/button-task-update.hook'

defineOptions({
  name: 'ButtonTaskUpdate',
})

const { setSubmitUpdate } = useButtonTaskUpdate()
</script>

<template>
  <BtnPrimary
    text="Save"
    color="emerald"
    @click="setSubmitUpdate"
  />
</template>
